import { Link } from "react-router-dom";

import { isAbsoluteURL } from "@eroad/helpers/isAbsoluteURL";
import { isIframe } from "@eroad/helpers/isIframe";
import { ArrowLeftOutlined } from "@eroad/icons/antd";

import { useStyles } from "./PageBreadcrumb.styles";
import type { PageBreadcrumbProps } from "./types";

/**
 * PageBreadcrumb is essentially a back button. It sits in the normal breadcrumbs spot and acts like a singular breadcrumb.
 */
const PageBreadcrumb = ({ children, backUrl, isBackCompat, ...props }: PageBreadcrumbProps) => {
  const classes = useStyles({ isBackCompat });

  if (isAbsoluteURL(backUrl)) {
    const target = isIframe() ? "_parent" : "_self";

    return (
      <a className={classes.root} href={backUrl} target={target} {...props}>
        <PageBreadcrumbContent>{children}</PageBreadcrumbContent>
      </a>
    );
  }

  return (
    <Link to={backUrl} className={classes.root} {...props}>
      <PageBreadcrumbContent>{children}</PageBreadcrumbContent>
    </Link>
  );
};

type PageBreadcrumbContentProps = {
  children: React.ReactNode;
};

/**
 * @internal
 */
const PageBreadcrumbContent = ({ children }: PageBreadcrumbContentProps): JSX.Element => (
  <>
    <ArrowLeftOutlined /> <span>{children}</span>
  </>
);

export { PageBreadcrumb };
